var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-modal',{attrs:{"name":"confirm-modal","primary-button-text":_vm.lang('Ja, kör på','Yes, continue'),"primary-button-class":"is-primary","title":_vm.lang('Bekräfta','Confirm'),"action":_vm.actionUrl,"redirect-to":_vm.redirectTo},on:{"before-open":_vm.beforeOpen}},[_vm._v("\n    "+_vm._s(_vm.lang('Är du säker','Are you sure'))+"?\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }